/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand interface.
 */
export function instanceOfFxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('GameJwtAccessTokenJwtString' in value) || value['GameJwtAccessTokenJwtString'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandFromJSON(json) {
    return FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
        'GameJwtAccessTokenJwtString': json['GameJwtAccessTokenJwtString'],
    };
}
export function FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSON(json) {
    return FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'GameJwtAccessTokenJwtString': value['GameJwtAccessTokenJwtString'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand.js.map